import { VideoPlayer } from '@sleepstation/components'
import { ASPECT_RATIOS, VIDEO_PROVIDERS } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const VideoContent = ({ videoId, aspectRatio, provider }) => (
  <VideoPlayer provider={provider} id={videoId} aspectRatio={aspectRatio} />
)

VideoContent.propTypes = {
  videoId: PropTypes.string.isRequired,
  aspectRatio: PropTypes.string,
  provider: PropTypes.string,
}

VideoContent.defaultProps = {
  aspectRatio: ASPECT_RATIOS.SIXTEEN_NINE,
  provider: VIDEO_PROVIDERS.VIMEO,
}

export default VideoContent
